// Roster › Free Agents — the subdued, anytime version of the free-agent list. It shares the
// list + offer flow with the offseason Free Agency screen (GmFreeAgency's FreeAgencyScreen)
// but renders calmer chrome (no offseason gradient/hero, no "days" countdown). Reached from
// the Roster screen's Free Agents tab; data comes from the `signings` view (aliased to
// `freeAgents` on the worker).

import type { View } from "../../common/types.ts";
import { FreeAgencyScreen } from "./GmFreeAgency.tsx";

const GmRosterSignings = (props: View<"signings">) => (
	<FreeAgencyScreen {...props} subdued />
);

export default GmRosterSignings;
